import graphql__fbdb656fb2ca6be4dbd5 from "./__generated__/AnswerPreviewThemes_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";
import findItemWithMatchingChildValue from "../Utils/findItemWithMatchingChildValue";

const AnswerPreviewThemes = props => {
  const { selectedThemeIds, formField } = props.answer;
  const { themes } = formField;

  const buildThemeLabelPathFor = (value, themes) => {
    const theme = findItemWithMatchingChildValue(themes, value);
    const label = theme?.label;

    if (!theme || !theme.children) {
      return label || [];
    } else {
      return [label].concat(buildThemeLabelPathFor(value, theme.children));
    }
  };

  const selectedThemesList = selectedThemeIds.map(selectedThemeId => {
    const themeLabelPath = buildThemeLabelPathFor(selectedThemeId, themes);
    const themeName = themeLabelPath.join(" / ");

    if (!themeLabelPath.length) return null;

    return <li key={selectedThemeId}>{themeName}</li>;
  });

  const listClassName = classNames([
    "form-answer-themes-values",
    "form-answer-themes-values-" + selectedThemesList.length
  ]);

  return <ul className={listClassName}>{selectedThemesList}</ul>;
};

export default createFragmentContainer(AnswerPreviewThemes, {
  answer: graphql__fbdb656fb2ca6be4dbd5
});
